import { z } from 'zod'

export const screeningFormSchema = (t: (key: string) => string) =>
  z.object({
    hemoglobin: z
      .string()
      .min(1, t('donor_detail.screening.validation.hemoglobin_required'))
      .refine((value) => !Number.isNaN(Number(value)), {
        message: t('donor_detail.screening.validation.hemoglobin_invalid'),
      }),
    blood_group_id: z
      .string()
      .min(1, t('donor_detail.screening.validation.blood_group_required')),
    rh_factor_id: z
      .string()
      .min(1, t('donor_detail.screening.validation.rh_factor_required')),
  })

export type ScreeningFormValues = z.infer<
  ReturnType<typeof screeningFormSchema>
>
